export default __webpack_public_path__ + "static/media/oscer-pres-alcohol-abuse.b61f5f2d.svg";